// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDnWRe_89dQ8cWoVXEr6syywdhSQElK-L0',
  authDomain: 'michelin-gp-colombia.firebaseapp.com',
  projectId: 'michelin-gp-colombia',
  storageBucket: 'michelin-gp-colombia.appspot.com',
  messagingSenderId: '46620167905',
  appId: '1:46620167905:web:43bb71f8eadaffce7971a0',
  measurementId: 'G-4LSC7V6FLE'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)

export default analytics

export function sendEvent(event, params) {
  logEvent(analytics, event, params)
}
